import React, { Component } from "react";
import { Button, Form } from "semantic-ui-react";

import { connect } from "react-redux";

import { updateReimbursementPreferences } from "../../actions/user";

const reimbursementNotificationOptions = [
  {
    text: "Immediate: Send me emails when reimbursements come in.",
    value: "immediate"
  },
  {
    text: "Daily: Send me a daily summary of new reimbursements.",
    value: "daily"
  },
  {
    text: "Weekly: Send me a weekly summary of new reimbursements.",
    value: "weekly"
  },
  {
    text: "Biweekly: Send me a biweekly summary of new reimbursements.",
    value: "biweekly"
  },
  {
    text: "Monthly: Send me a monthly summary of new reimbursements.",
    value: "monthly"
  },
  {
    text: "Never: Never notify me of new reimbursements.",
    value: "never"
  }
];

class NotificationsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reimbursement_notifications: props.reimbursement_notifications,
      submitting: false,
      error: false
    };
  }

  validateForm() {
    return this.state.first_name.length > 0 && this.state.last_name.length > 0;
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({
      submitting: true
    });

    updateReimbursementPreferences(this.state.reimbursement_notifications)
      .then(() => {
        this.setState({
          error: false
        });
      })
      .catch(e => {
        this.setState({
          error: e
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  render() {
    return (
      <Form loading={this.state.submitting} onSubmit={this.handleSubmit}>
        <Form.Select
          fluid
          selection
          id="reimbursement_notifications"
          label="Reimbursement Notifications"
          options={reimbursementNotificationOptions}
          value={this.state.reimbursement_notifications}
          error={this.state.error}
          disabled
          onChange={(e, { value }) =>
            this.setState({
              reimbursement_notifications: value,
              error: false
            })
          }
        />
        <Button type="submit" primary disabled={true || this.state.submitting}>
          Update
        </Button>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  reimbursement_notifications: state.user.profile.reimbursement_notifications
});

export default connect(mapStateToProps)(NotificationsForm);



// WEBPACK FOOTER //
// ./frontend/src/components/forms/NotificationsForm.js